import AppState from "store/AppState";
import { LinkedCategoryPane } from "./LinkedCategoriesTypes";

export const selectLinkedCategories = (state: AppState) =>
  state.linkedCategories.data;

export const selectLinkedCategoriesLoading = (state: AppState) =>
  state.linkedCategories.loading;

export const selectLinkedCategoriesUploadProgress = (state: AppState) =>
  state.linkedCategories.uploadProgress;

export const selectLinkedCategoriesUploadSuccess = (state: AppState) =>
  state.linkedCategories.isUploadSuccess;

export const selectLinkedCategorySetByCategory = (
  state: AppState,
  storeId: string | null,
  catalogId: string,
  categoryId: string,
) =>
  state.linkedCategories.linkedCategorySetByCategory.categories.filter(
    (category) =>
      !(
        category.storeId === storeId &&
        category.catalogId === catalogId &&
        category.categoryId === categoryId
      ),
  );

export const selectCategorySearchResults = (
  state: AppState,
  pane: LinkedCategoryPane,
) => state.linkedCategories.categorySearch[pane].results;

export const selectCategorySearchLoading = (
  state: AppState,
  pane: LinkedCategoryPane,
) => state.linkedCategories.categorySearch[pane].loading;

export const selectLinkedCategoryLabels = (state: AppState) =>
  state.linkedCategories.categoryLabels;
